import { useState } from "react";

import { history } from "src/App";
import { CCheckbox } from "src/common/components/controls";
import { CPagination, CTable } from "src/common/components/others";
import { format as formatDate } from "src/utils/dayjs";

export const SuggestListTable = ({
  data = [],
  loading,
  isSelectAll,
  onSelect,
}) => {
  //#region Data
  const [paginate, setPaginate] = useState({ page: 1, limit: 10 });
  //#endregion

  //#region Event
  const onPageChange = (_paginate) => setPaginate(_paginate);

  const select =
    (code = -1) =>
    (e) =>
      onSelect(code, e);
  //#endregion

  //#region Render
  const fields = [
    {
      key: "select",
      label: <CCheckbox value={isSelectAll} onChange={select()} />,
      sorter: false,
    },
    {
      key: "code",
      label: "Số phiếu",
      _style: { width: "220px", minWidth: "220px", textAlign: "left" },
      sorter: false,
    },
    {
      key: "cycle",
      label: "Kỳ đánh giá",
      _style: { width: "130px", minWidth: "130px" },
      sorter: false,
    },
    {
      key: "year",
      label: "Năm",
      _style: { width: "130px", minWidth: "130px" },
      sorter: false,
    },
    {
      key: "evaluation_date",
      label: "Ngày đánh giá",
      _style: { width: "250px", minWidth: "250px" },
      sorter: false,
    },
    {
      key: "suppliers",
      label: "Số nhà cung cấp",
      _style: { width: "170px", minWidth: "170px" },
      sorter: false,
    },
    {
      key: "pass",
      label: "NCC đạt",
      _style: { width: "170px", minWidth: "170px" },
      sorter: false,
    },
    {
      key: "fail",
      label: "NCC không đạt",
      _style: { width: "170px", minWidth: "170px" },
      sorter: false,
    },
    {
      key: "note",
      label: "Ghi chú",
      _style: { width: "250px", minWidth: "250px", textAlign: "left" },
      sorter: false,
    },
  ];

  const render = {
    select: ({ code, check }) => (
      <td>
        <CCheckbox value={check} onChange={select(code)} />
      </td>
    ),
    code: ({ code, id }) => (
      <td className="text-left">
        <span
          className="text-blue-700 font-medium text-left"
          onClick={() => history.push(`/supplier-suggest/rating/${id}`)}
        >
          {code}
        </span>
      </td>
    ),
    evaluation_date: ({ evaluation_date }) => (
      <td>{formatDate(evaluation_date)}</td>
    ),
    note: ({ note }) => <td className="text-left">{note}</td>,
  };

  return (
    <>
      <CTable
        className="selectable"
        loading={loading}
        data={data}
        page={paginate.page}
        itemsPerPage={paginate.limit}
        fields={fields}
        render={render}
        footer={
          <CPagination
            page={paginate.page}
            total={data?.length}
            limit={paginate.limit}
            onPaginationChange={onPageChange}
          />
        }
      />
    </>
  );
  //#endregion
};
